export const dateFormats = {
    DMY: 'DD.MM.YYYY',
    YMD: 'YYYY-MM-DD',
    HM: 'HH:mm',
};
//# sourceMappingURL=dateFormats.js.map